module.exports = __webpack_public_path__ + "img/pro_seven_4.dd8eae86.jpg";